export { TableModule } from "./table-module";



// WEBPACK FOOTER //
// ./lib/ts/modules/table/index.ts